export const LOGIN_OUT = "LOGIN_OUT";
export const LOGIN_IN = "LOGIN_IN";
export const LOGIN_CANCEL = "LOGIN_CANCEL";

export const USER_UPDATE = "USER_UPDATE";